//#region Styles
import Preloader from "components/Preloader/Preloader";
import {
    ContainerParts 
} from "components/styles";
//#endregion
//#region Components
import ResumeStep1 from "./components/ResumeStep1/ResumeStep1";
import ResumeStep2 from "./components/ResumeStep2/ResumeStep2";
//#endregion

const AppointmentDetail = ({
    toStep,
    dataRelatedToForm: {
        allCampus,
        allDays,
        modalities,
        locations,
    }, form
}) => {
    return (
        <ContainerParts>
            <Preloader
                hidden={true}
                message="Cargando..."/>
                <>
                <ResumeStep1 
                    toStep1={() => toStep(1)}
                    form={form.step1}
                    allDays={allDays}
                />
                <ResumeStep2 
                    toStep2={() => toStep(2)}
                    form={form.step2}
                    allCampus={allCampus}
                    modalities={modalities}
                    locations={locations}
                />
                </>
        </ContainerParts>
    )
}


export default AppointmentDetail;